import React, { FunctionComponent, useCallback, useMemo } from 'react'
import { GenericInput, Translation } from '@dxp-module/common'
import { Box, InputAdornment } from '@mui/material'
import clsx from 'clsx'
import { MyAccountWidgetProps } from '../../../model/MyAccountWidgetProps'
import phoneWithPrefixStyles from './phoneWithPrefix.styles'

const PhoneWithPrefix: FunctionComponent<MyAccountWidgetProps> = props => {
  const {
    label,
    required,
    id,
    onChange,
    value,
    options,
    placeholder,
    rawErrors,
    disabled,
    schema,
  } = props

  const { readOnly, disabled: schemaDisabled } = schema as typeof schema & {
    disabled: boolean
  }

  const handleChange = useCallback(
    (e: React.ChangeEvent<{ value: string }>) => {
      onChange(e.target.value as string)
    },
    [value]
  )

  const currentError = useMemo(() => {
    if (rawErrors) {
      return rawErrors?.length > 0 ? rawErrors[0] : undefined
    }
  }, [rawErrors])

  const styles = phoneWithPrefixStyles()

  const isDisabled = disabled || schemaDisabled

  return (
    <GenericInput
      label={label}
      required={required}
      id={id}
      value={value}
      currentError={
        currentError
          ? {
              props: {
                id: currentError,
                defaultMessage: currentError,
              },
            }
          : undefined
      }
      onChange={handleChange}
      type={String(options?.inputType) || undefined}
      inputLabel={!!options?.inputLabel || !!label}
      placeholder={placeholder}
      disabled={isDisabled}
      readOnly={readOnly}
      startAdornment={
        <InputAdornment
          position="start"
          classes={{
            root: clsx(styles.startAdornment, {
              [styles.disabled]: isDisabled,
            }),
          }}
        >
          <Box
            className={styles.phonePrefix}
            data-test={`text_input:prefix:${id}`}
          >
            <Translation id={'trans__checkout__enquiry_form__phone_prefix'} />
          </Box>
        </InputAdornment>
      }
      classes={{
        root: styles.root,
        fieldWrapper: styles.fieldWrapper,
        input: clsx(styles.input, styles.phoneInput),
        errorText: styles.errorText,
        notchedOutline: styles.notchedOutline,
        focused: styles.focused,
        inputError: styles.inputError,
        helperTextError: styles.helperTextError,
        dateCalendar: styles.dateCalendar,
        label: styles.label,
        noOptions: styles.noOptions,
        inputNoLabel: styles.inputNoLabel,
        labelContainer: styles.labelContainer,
        labelAsterisk: styles.labelAsterisk,
        disabled: styles.disabled,
      }}
    />
  )
}

export default PhoneWithPrefix
